import { makeStyles } from '@material-ui/core/styles';

import { colors } from '../../../../../theme';

export const useStyles = makeStyles(() => ({
    launchExtensionWrapper: {
        position: 'relative'
    },
    menuPaper: {
        backgroundColor: colors.blackRock,
        border: `1px solid ${colors.lightningYellow}`,
        borderRadius: '8px',
        marginTop: '12px',
        boxShadow: `0px 4px 20px ${colors.black87}`,
        '& .MuiList-root': {
            padding: '8px 0'
        }
    },
    menuItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '12px 16px',
        minWidth: '220px',
        '&:hover': {
            backgroundColor: colors.lightOrangeYellow
        }
    },
    menuText: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.white90
    }
}));
